/*
 * Плашка «запрос на объединение» для аккаунта, где уже есть телефон.
 * Грузит входящие запросы сама; кнопки Подтвердить/Отклонить.
 */
import React, { useState, useEffect } from 'react';
import client from '../api/client';
import { toast } from './Toast/toast';

export default function MergeRequestBanner({ className = '' }) {
  const [request, setRequest] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    client.get('/users/me/merge-requests')
      .then(res => setRequest(res.data?.[0] || null))
      .catch(() => {}); // нет запросов или не авторизован — плашки нет
  }, []);

  const act = async (action) => {
    setBusy(true);
    try {
      await client.post(`/users/merge-requests/${request.id}/${action}`);
      setRequest(null);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Ошибка');
    } finally {
      setBusy(false);
    }
  };

  if (!request) return null;
  const name = request.first_name || request.username || 'Пользователь';

  return (
    <div className={`rounded-2xl bg-yellow-soft p-4 ring-1 ring-border-warm space-y-2 ${className}`}>
      <div className="text-sm font-semibold text-green-dark">Подтвердить объединение аккаунтов?</div>
      <div className="text-xs text-green-dark leading-relaxed">
        {name} ввёл ваш номер {request.phone} в своём профиле и хочет
        перенести свои данные (заказы, избранное) к вам. Подтвердите, если это он
        или вы сами. Если номер попал к постороннему — отклоните.
        Срок подтверждения — 15 минут.
      </div>
      <div className="flex gap-2 pt-1">
        <button
          onClick={() => act('confirm')}
          disabled={busy}
          className="flex-1 rounded-xl bg-green-primary py-2.5 text-sm font-semibold text-white hover:opacity-90 transition active:scale-[0.98] disabled:opacity-50"
        >
          Подтвердить
        </button>
        <button
          onClick={() => act('reject')}
          disabled={busy}
          className="flex-1 rounded-xl border border-border-warm bg-cream py-2.5 text-sm font-medium text-green-muted hover:bg-cream transition active:scale-[0.98] disabled:opacity-50"
        >
          Отклонить
        </button>
      </div>
    </div>
  );
}
